/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreditCardPaymentSummary {
  amount?: number;
  attempt?: number;
  authorizationCode?: string;
  authorizationMessage?: string;
  creditCardId?: number;
  creditCardPaymentId?: number;
  creditCardPaymentType?: string;
  creditCardPaymentTypeId?: number;
  dateAuthorized?: Date;
  dateCreated?: Date;
  extraData?: string;
  gatewayId?: number;
  gatewayName?: string;
  installments?: number;
  ipAddress?: string;
  lr?: string;
  nextStep?: string;
  nsu?: string;
  pan?: string;
  paymentGuid?: string;
  paymentId?: number;
  personId?: number;
  personName?: string;
  recurrence?: number;
  subscriberId?: number;
  subscriberPendingFeeId?: number;
  subscriptionName?: string;
  subscriptionTypeName?: string;
  tid?: string;
  transactionStatusId?: number;
  transactionStatusName?: string;
}
